import { DataBean } from "../../DataBean";


export class ClinicalDocumentType extends DataBean {

    public async getClinicalDocumentTypeConstants(args: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getClinicalDocumentTypeConstants_Number", [args]);
    }

}